import {
  SET_TRANSFER_LIST,
  SET_TRANSFER_LIST_PAGE,
  SET_TRANSFER_LIST_PAGE_TOTAL,
  SET_TRANSFER_LIST_QUERY,
  SET_TRANSFER_LIST_PAGE_SIZE,
  SET_TRANSFER_LIST_SEARCHING,
  SET_RENTAL_RECORD_STATE,
  SET_RENTAL_RECORD_QUERY,

  SET_MACHINE_DETAIL_LIST,
  SET_MACHINE_DETAIL_LIST_PAGE,
  SET_MACHINE_DETAIL_LIST_PAGE_TOTAL,
  SET_MACHINE_DETAIL_LIST_PAGE_SIZE,
  SET_MACHINE_DETAIL_LIST_ID,
  SET_MACHINE_DETAIL_LIST_STATUS,

  SET_OPERATE_RECORD_LIST,
  SET_OPERATE_RECORD_LIST_PAGE,
  SET_OPERATE_RECORD_LIST_PAGE_TOTAL,
  SET_OPERATE_RECORD_LIST_PAGE_SIZE,
  SET_OPERATE_RECORD_LIST_ID,
} from './mutation-types'
import api from '@/api'
import {objectTrim} from '@/utils'
import { checkUserName } from '@/views/User/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  startTime: '',
  endTime: '',
  leaseUserName: '',
  status: '',
})
const initMachine = () => ({
  pageNum: 1,
  pageSize: 50,
  id: '',
  renderToLeaseStatus: '',
})
const initOperate = () => ({
  pageNum: 1,
  pageSize: 50,
  id: '',
})
const createRecordQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  transferInStartTime: '',
  transferInEndTime: '',
  transferOutStartTime: '',
  transferOutEndTime: '',
  leaseUserName: '',
})

const toPlatformRecordParams = query => {
  const {
    transferInStartTime,
    transferInEndTime,
    transferOutStartTime,
    transferOutEndTime,
    ...params
  } = objectTrim(query)
  return {
    ...params,
    queryType: 1,
    ...(transferInStartTime ? {transferInTimeStart: transferInStartTime} : {}),
    ...(transferInEndTime ? {transferInTimeEnd: transferInEndTime} : {}),
    ...(transferOutStartTime ? {transferOutTimeStart: transferOutStartTime} : {}),
    ...(transferOutEndTime ? {transferOutTimeEnd: transferOutEndTime} : {}),
  }
}

const toThirdRecordParams = query => {
  const {
    leaseUserName,
    transferInStartTime,
    transferInEndTime,
    transferOutStartTime,
    transferOutEndTime,
    ...params
  } = objectTrim(query)
  return {
    ...params,
    queryType: 1,
    ...(leaseUserName ? {userName: leaseUserName} : {}),
    ...(transferInStartTime ? {transferInTimeStart: transferInStartTime} : {}),
    ...(transferInEndTime ? {transferInTimeEnd: transferInEndTime} : {}),
    ...(transferOutStartTime ? {transferOutTimeStart: transferOutStartTime} : {}),
    ...(transferOutEndTime ? {transferOutTimeEnd: transferOutEndTime} : {}),
  }
}

const mapPlatformRecord = item => ({
  ...item,
  hardwareModel: item.hardwareModeName,
  leasePlan: item.leasePlanName,
  salesperson: item.salesmanName,
  transferInTime: item.startTime,
  transferOutTime: item.endTime,
})

const mapThirdRecord = item => ({
  ...item,
  resourceId: item.instanceId,
  ip: item.instanceIp,
  leaseUserName: item.userName,
  instanceType: item.flavorId,
  hardwareModel: item.instanceType,
})

let rentalRecordRequestId = 0

const createRecordView = type => ({
  loading: false,
  error: '',
  list: [],
  total: 0,
  query: createRecordQuery(type),
  requestId: 0,
})
const state = {
  searching: false,
  initQuery: initQuery(),
  rentalRecords: {
    platform: createRecordView('platform'),
    publicCloud: createRecordView('publicCloud'),
  },
  transferMessage: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
  machineDetails: {
    list: [],
    listPageTotal: 0,
    query: initMachine(),
  },
  operateRecord: {
    list: [],
    listPageTotal: 0,
    query: initOperate(),
  },
}

const mutations = {
  [SET_TRANSFER_LIST] (state, payload) {
    state.transferMessage.list = payload
  },
  [SET_TRANSFER_LIST_QUERY] (state, payload) {
    state.transferMessage.query = {
      ...state.transferMessage.query,
      ...payload,
    }
  },
  [SET_TRANSFER_LIST_PAGE] (state, payload) {
    state.transferMessage.query.pageNum = payload
  },
  [SET_TRANSFER_LIST_PAGE_SIZE] (state, payload) {
    state.transferMessage.query.pageSize = payload
  },
  [SET_TRANSFER_LIST_PAGE_TOTAL] (state, payload) {
    state.transferMessage.listPageTotal = payload
  },
  [SET_TRANSFER_LIST_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_RENTAL_RECORD_STATE] (state, {type, payload}) {
    state.rentalRecords[type] = {
      ...state.rentalRecords[type],
      ...payload,
    }
  },
  [SET_RENTAL_RECORD_QUERY] (state, {type, payload}) {
    state.rentalRecords[type].query = {
      ...state.rentalRecords[type].query,
      ...payload,
    }
  },
  [SET_MACHINE_DETAIL_LIST] (state, payload) {
    state.machineDetails.list = payload
  },
  [SET_MACHINE_DETAIL_LIST_ID] (state, payload) {
    state.machineDetails.query.id = payload
  },
  [SET_MACHINE_DETAIL_LIST_STATUS] (state, payload) {
    state.machineDetails.query.renderToLeaseStatus = payload
  },
  [SET_MACHINE_DETAIL_LIST_PAGE] (state, payload) {
    state.machineDetails.query.pageNum = payload
  },
  [SET_MACHINE_DETAIL_LIST_PAGE_SIZE] (state, payload) {
    state.machineDetails.query.pageSize = payload
  },
  [SET_MACHINE_DETAIL_LIST_PAGE_TOTAL] (state, payload) {
    state.machineDetails.listPageTotal = payload
  },
  [SET_OPERATE_RECORD_LIST] (state, payload) {
    state.operateRecord.list = payload
  },
  [SET_OPERATE_RECORD_LIST_ID] (state, payload) {
    state.operateRecord.query.id = payload
  },
  [SET_OPERATE_RECORD_LIST_PAGE] (state, payload) {
    state.operateRecord.query.pageNum = payload
  },
  [SET_OPERATE_RECORD_LIST_PAGE_SIZE] (state, payload) {
    state.operateRecord.query.pageSize = payload
  },
  [SET_OPERATE_RECORD_LIST_PAGE_TOTAL] (state, payload) {
    state.operateRecord.listPageTotal = payload
  },
}

const actions = {
  async queryRentalRecords ({commit, state}, {type, query = {}}) {
    commit(SET_RENTAL_RECORD_QUERY, {type, payload: query})
    const requestId = ++rentalRecordRequestId
    commit(SET_RENTAL_RECORD_STATE, {type, payload: {loading: true, requestId}})
    try {
      const sourceQuery = state.rentalRecords[type].query
      const request = type === 'publicCloud'
        ? api.nodeApi.getThirdLeaseNodeList
        : api.nodeApi.getLeaseNodeList
      const params = type === 'publicCloud'
        ? toThirdRecordParams(sourceQuery)
        : toPlatformRecordParams(sourceQuery)
      const mapper = type === 'publicCloud' ? mapThirdRecord : mapPlatformRecord
      const {data} = await request(params)
      const page = data || {}
      if (state.rentalRecords[type].requestId !== requestId) return page
      commit(SET_RENTAL_RECORD_STATE, {
        type,
        payload: {
          error: '',
          list: (page.items || []).map(mapper),
          total: page.total || 0,
          query: {
            ...sourceQuery,
            pageNum: page.pageNum || 1,
            pageSize: page.size || sourceQuery.pageSize,
          },
        },
      })
      return page
    } catch (error) {
      if (state.rentalRecords[type].requestId === requestId) {
        commit(SET_RENTAL_RECORD_STATE, {
          type,
          payload: {error: error.message, list: [], total: 0},
        })
      }
      throw error
    } finally {
      if (state.rentalRecords[type].requestId === requestId) {
        commit(SET_RENTAL_RECORD_STATE, {type, payload: {loading: false}})
      }
    }
  },
  resetRentalRecords ({commit, dispatch}, type) {
    commit(SET_RENTAL_RECORD_STATE, {type, payload: createRecordView(type)})
    return dispatch('queryRentalRecords', {type})
  },
  changeRentalRecordQuery ({commit}, {type, query}) {
    commit(SET_RENTAL_RECORD_QUERY, {type, payload: query})
  },
  async exportRentalRecords ({state, rootState}, payload) {
    const type = typeof payload === 'string' ? payload : payload.type
    const sourceQuery = typeof payload === 'string'
      ? state.rentalRecords[type].query
      : payload.query || state.rentalRecords[type].query
    const {pageNum, pageSize, ...query} = sourceQuery
    const platform = rootState.home.platform
    if (type === 'publicCloud') {
      return api.statisticsApi.exportThirdLeaseNodeList({
        ...toThirdRecordParams(query),
        platform,
      })
    }
    return api.statisticsApi.exportTransferRecord({
      ...toPlatformRecordParams(query),
      platform,
    })
  },
  // 获取转入记录列表
  async getTransferlist ({commit, state, dispatch}, payload) {
    try {
      let param = {
        ...objectTrim(state.transferMessage.query),
        ...objectTrim(payload),
      }
      if (payload && !payload.leaseUserName && param.leaseUserName) {
        delete param.leaseUserName
      }
      commit(SET_TRANSFER_LIST_SEARCHING, true)
      const {data, code} = await api.nodeApi.getTransferlist(param)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { leaseUserName, ...other } = param
          dispatch('getTransferlist', {
            ...other,
            userId,
          })
        },
      })
      if (data) {
        commit(SET_TRANSFER_LIST_PAGE, data.pageNum || 1)
        commit(SET_TRANSFER_LIST_PAGE_TOTAL, data.total || 0)
        commit(SET_TRANSFER_LIST, data.items || [])
        commit(SET_TRANSFER_LIST_PAGE_SIZE, data.size)
      }
    } catch (error) {
      commit(SET_TRANSFER_LIST_PAGE_TOTAL, 0)
      commit(SET_TRANSFER_LIST, [])
    }
    commit(SET_TRANSFER_LIST_SEARCHING, false)
  },
  // 初始化转入记录
  async initTransferList ({commit, dispatch}, payload) {
    await dispatch('changeTransferMessageQuery', {
      pageNum: 1,
      pageSize: 50,
      startTime: '',
      endTime: '',
      leaseUserName: '',
      status: '',
    })
    await dispatch('getTransferlist')
  },
  // 转入记录列表翻页
  async changeTransferListPage ({commit, state, dispatch}, payload) {
    commit(SET_TRANSFER_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('getTransferlist')
    return Promise.resolve(true)
  },
  // 改变每页显示条数
  async changePageSize ({commit, dispatch}, payload) {
    commit(SET_TRANSFER_LIST_PAGE_SIZE, payload.listPageSize)
    return Promise.resolve(true)
  },
  // 转入记录列表筛选
  async changeTransferMessageQuery ({commit, state, dispatch}, payload) {
    commit(SET_TRANSFER_LIST_QUERY, payload)
  },
  // 关闭转入
  async closeTransferRecord({commit, state, dispatch}, payload) {
    const {code} = await api.nodeApi.closeTransferRecord(payload)
    if (code === 200) {
      dispatch('getTransferlist')
    }
    return code
  },
  // 编辑转入记录
  async editTransferRecord ({dispatch}, payload) {
    let param = {
      ...payload,
    }
    const {result, message, code} = await api.nodeApi.editTransferRecord(param)
    if (result) {
      dispatch('getTransferlist')
    }
    return {result, message, code}
  },
  // 机器详情
  async machineDetailsList ({commit, state, dispatch}, payload) {
    try {
      commit(SET_MACHINE_DETAIL_LIST_ID, payload.id)
      let param = {
        ...objectTrim(state.machineDetails.query),
        ...objectTrim(payload),
      }
      let {data} = await api.nodeApi.machineDetailsList(param)
      if (data) {
        commit(SET_MACHINE_DETAIL_LIST_PAGE, data.pageNum || 1)
        commit(SET_MACHINE_DETAIL_LIST_PAGE_TOTAL, data.total || 0)
        commit(SET_MACHINE_DETAIL_LIST, data.items || [])
        commit(SET_MACHINE_DETAIL_LIST_PAGE_SIZE, data.size)
      }
    } catch (error) {
      commit(SET_MACHINE_DETAIL_LIST_PAGE_TOTAL, 0)
      commit(SET_MACHINE_DETAIL_LIST, [])
    }
  },
  // 筛选状态
  async filterStatus ({commit, state, dispatch}, payload) {
    commit(SET_MACHINE_DETAIL_LIST_STATUS, payload.renderToLeaseStatus)
    await dispatch('machineDetailsList', payload)
  },
  // 机器详情列表翻页
  async changeMachineDetailsPage ({commit, state, dispatch}, payload) {
    commit(SET_MACHINE_DETAIL_LIST_PAGE, payload.pageNum)
    await dispatch('machineDetailsList', payload)
    return Promise.resolve(true)
  },
  // 机器详情改变每页显示条数
  async changeMachineDetailsPageSize ({commit, dispatch}, payload) {
    commit(SET_MACHINE_DETAIL_LIST_PAGE_SIZE, payload.pageSize)
    await dispatch('machineDetailsList', payload)
    return Promise.resolve(true)
  },
  // 转入记录列表统计
  async countNum({commit, dispatch}, payload) {
    const {data} = await api.nodeApi.countNum(payload)
    return data
  },
  // 操作记录
  async getOperationRecord ({commit, state, dispatch}, payload) {
    try {
      commit(SET_OPERATE_RECORD_LIST_ID, payload.id)
      let param = {
        ...objectTrim(state.operateRecord.query),
        ...payload,
      }
      let {data} = await api.nodeApi.getOperationRecord(param)
      if (data) {
        commit(SET_OPERATE_RECORD_LIST_PAGE, data.pageNum || 1)
        commit(SET_OPERATE_RECORD_LIST_PAGE_TOTAL, data.total || 0)
        commit(SET_OPERATE_RECORD_LIST, data.item || [])
        commit(SET_OPERATE_RECORD_LIST_PAGE_SIZE, data.pageSize)
      }
    } catch (error) {
      commit(SET_OPERATE_RECORD_LIST_PAGE_TOTAL, 0)
      commit(SET_OPERATE_RECORD_LIST, [])
    }
  },
  // 操作记录列表翻页
  async changeOperateRecordPage ({commit, state, dispatch}, payload) {
    commit(SET_OPERATE_RECORD_LIST_PAGE, payload.pageNum)
    await dispatch('getOperationRecord', payload)
    return Promise.resolve(true)
  },
  // 操作记录改变每页显示条数
  async changeOperateRecordPageSize ({commit, dispatch}, payload) {
    commit(SET_OPERATE_RECORD_LIST_PAGE_SIZE, payload.pageSize)
    await dispatch('getOperationRecord', payload)
    return Promise.resolve(true)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
